import PropTypes from 'prop-types';
export const reviewsListPropTypes = {
  reviews: PropTypes.arrayOf(PropTypes.shape({
    stars: PropTypes.string,
    date: PropTypes.string,
    text: PropTypes.string
  })),
  showMoreButtonText: PropTypes.string
};